import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, searchparam: string[]): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toString().toLocaleLowerCase();
    return items.filter(eachItem => {
      if (searchparam.length == 6) {
        return (
          eachItem[searchparam[2]].toLowerCase().includes(searchText.toLowerCase()) ||
          eachItem[searchparam[1]][searchparam[3]].toLowerCase().includes(searchText.toLowerCase()) ||
          eachItem[searchparam[1]][searchparam[4]][searchparam[5]].toLowerCase().includes(searchText.toLowerCase())
        )
        
      } else if (searchparam.length == 4) {
       var createdbylastnamefolderfile;
        try {
          createdbylastnamefolderfile = eachItem[searchparam[1]][searchparam[3]].toLowerCase().includes(searchText.toLowerCase())
        }catch(err){}
        
        if(createdbylastnamefolderfile){
        return (
          eachItem[searchparam[0]].toLowerCase().includes(searchText.toLowerCase()) ||
          eachItem[searchparam[1]][searchparam[2]].toLowerCase().includes(searchText.toLowerCase()) ||
          eachItem[searchparam[1]][searchparam[3]].toLowerCase().includes(searchText.toLowerCase())
        )}else{
          return (
            eachItem[searchparam[0]].toLowerCase().includes(searchText.toLowerCase()) ||
            eachItem[searchparam[1]][searchparam[2]].toLowerCase().includes(searchText.toLowerCase())
          )
        }
      } else if (searchparam.length == 5) {
        const createdbyfirstname = eachItem[searchparam[4]][searchparam[2]].toLowerCase().includes(searchText.toLowerCase())
        const createdbylastname = eachItem[searchparam[4]][searchparam[3]].toLowerCase().includes(searchText.toLowerCase())

        var modifiedbyfirstname;
        var modifiedbylastname;
        try {
          modifiedbyfirstname = eachItem[searchparam[1]][searchparam[2]].toLowerCase().includes(searchText.toLowerCase())
          modifiedbylastname = eachItem[searchparam[1]][searchparam[3]].toLowerCase().includes(searchText.toLowerCase())
        } catch (err) {
          try {
            modifiedbylastname = eachItem[searchparam[1]][searchparam[3]].toLowerCase().includes(searchText.toLowerCase())
          } catch (err1) { }
        }

        if (modifiedbyfirstname || modifiedbylastname) {
          return (
            eachItem[searchparam[0]].toLowerCase().includes(searchText.toLowerCase()) ||
            eachItem[searchparam[1]][searchparam[2]].toLowerCase().includes(searchText.toLowerCase()) ||
            eachItem[searchparam[1]][searchparam[3]].toLowerCase().includes(searchText.toLowerCase())
          )
        } else if (createdbyfirstname || createdbylastname) {
          return (
            eachItem[searchparam[0]].toLowerCase().includes(searchText.toLowerCase()) ||
            eachItem[searchparam[4]][searchparam[2]].toLowerCase().includes(searchText.toLowerCase()) ||
            eachItem[searchparam[4]][searchparam[3]].toLowerCase().includes(searchText.toLowerCase())
          )
        } else {
          return (
            eachItem[searchparam[0]].toString().toLowerCase().includes(searchText.toLowerCase())
          )
        }
      } else if (searchparam.length == 1){
        return (
          eachItem[searchparam[0]].toString().toLowerCase().includes(searchText.toLowerCase())
        )
      }
    });
  }
}
